"use strict";

require("./en");

require("./fr");